import { render, staticRenderFns } from "./AiRequirementsTab.vue?vue&type=template&id=25ec60de&scoped=true"
import script from "./AiRequirementsTab.vue?vue&type=script&lang=js"
export * from "./AiRequirementsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec60de",
  null
  
)

export default component.exports